import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { EmtTheme } from "../types";

export type EmtStepperProps = BoxProps & {
  /**
   * Total step to show
   * @default 3
   */
  totalStep?: number;
  /**
   * Current step
   * @default 1
   */
  currentStep?: number;
  nonce?: string;
};

type StepProps = BoxProps & {
  isActive: boolean;
  theme?: EmtTheme;
};
const Step = styled(Box)((props: StepProps) => {
  const { theme, isActive } = props;
  return {
    width: isActive ? "37px" : "26px",
    height: "4px",
    borderRadius: "20px",
    backgroundColor: isActive
      ? theme?.palette.primary.main
      : theme?.palette.greyGradient
      ? theme?.palette.greyGradient[150]
      : "#D2D1D4",
  };
});

export function EmtStepper(props: EmtStepperProps) {
  const { totalStep = 3, currentStep = 1, sx, ...rest } = props;
  const stepNumberArray = [...Array(totalStep)];
  return (
    <Box
      {...rest}
      sx={{
        display: "flex",
        gap: "8px",
        justifyContent: "center",
        ...sx,
      }}
    >
      {stepNumberArray.map((e, key) => (
        <Step key={key} isActive={currentStep === key + 1} />
      ))}
    </Box>
  );
}
